export default function LikertSection({ section, value, onChange }) {
  const { min, max, labels } = section.scale;
  const opts = [];
  for (let i = min; i <= max; i++) opts.push(i);

  return (
    <div className="space-y-4" data-testid="likert-section">
      <div className="hidden sm:flex gap-2 text-[10px] uppercase tracking-wider text-[color:var(--cand-muted)] pl-[52%]">
        {opts.map((o, i) => (
          <span key={o} className="flex-1 text-center leading-tight">
            {labels?.[i]}
          </span>
        ))}
      </div>
      {section.items.map((item, idx) => (
        <div
          key={item.id}
          className="cand-card rounded-lg p-4 sm:flex sm:items-center sm:gap-4"
          data-testid={`likert-item-${item.id}`}
        >
          <p className="text-sm sm:w-1/2 leading-relaxed">
            <span className="font-data text-xs text-[color:var(--cand-muted)] mr-2">
              {String(idx + 1).padStart(2, "0")}
            </span>
            {item.prompt}
          </p>
          <div className="flex gap-2 mt-3 sm:mt-0 sm:w-1/2">
            {opts.map((o) => (
              <button
                key={o}
                type="button"
                data-selected={value[item.id] === o}
                style={
                  value[item.id] === o
                    ? { background: "#C05621", color: "#fff", borderColor: "#C05621" }
                    : undefined
                }
                className="likert-opt flex-1 border rounded py-2 text-sm bg-white font-data"
                data-testid={`likert-${item.id}-option-${o}`}
                aria-label={`${item.prompt} — ${labels?.[o - min] || o}`}
                onClick={() => onChange({ ...value, [item.id]: o })}
              >
                {o}
              </button>
            ))}
          </div>
        </div>
      ))}
      <p className="text-xs text-[color:var(--cand-muted)]" data-testid="likert-progress">
        {Object.keys(value).length} of {section.items.length} answered
      </p>
    </div>
  );
}
